// extracted by mini-css-extract-plugin
module.exports = {"container":"LatestReadings_container__3IzNj"};